import { FC, ReactNode } from 'react';

import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonTheme } from 'react-loading-skeleton';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

// Use SG-BS color palette for loading skeletons
export const LoadingSkeletonTheme: FC<{
  children: ReactNode;
  theme: SgBsTheme;
}> = ({ children, theme }) => {
  return (
    <SkeletonTheme
      baseColor={theme === 'dark' ? '#303333' : '#eceeef'}
      highlightColor={theme === 'dark' ? '#515757' : '#e3e6e7'}
    >
      {children}
    </SkeletonTheme>
  );
};
LoadingSkeletonTheme.displayName = 'LoadingSkeletonTheme';
